<div class="dismiss with-icon">
  <span>
    {{data}}
    <button mat-icon-button (click)="sbRef.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </span>
</div>